import { ConfigForm } from '@/components/config/ConfigForm'
import { useToast } from '@/hooks/use-toast'
import { useConfig } from '@/hooks/config/useConfig'
import type { Config } from '@/api/types/config'
import { useAuth } from '@/context/AuthContext'

export default function ConfigPage() {
  const { toast } = useToast()
  const { selectedOrganizationId, selectedWorkspaceId } = useAuth()
  const { config, isLoading, error, updateConfig } = useConfig()

  if (error) {
    toast({
      title: "Error",
      description: "Failed to fetch configuration.",
      variant: "destructive"
    })
  }

  const handleSubmit = async (data: Partial<Config>) => {
    try {
      await updateConfig.mutateAsync(data)
      toast({
        title: "Success",
        description: "Configuration updated successfully."
      })
    } catch {
      toast({
        title: "Error",
        description: "Failed to update configuration.",
        variant: "destructive"
      })
    }
  }

  // Check if workspace is selected
  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return (
      <div className="container mx-auto p-6">
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-600">Please select an organization and workspace to view configuration.</p>
        </div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="container mx-auto p-6">
        <div className="flex justify-center items-center h-64">
          Loading...
        </div>
      </div>
    )
  }

  if (!config) {
    return (
      <div className="container mx-auto p-6">
        <div className="flex justify-center items-center h-64">
          <p className="text-gray-600">No configuration found in database. Please create a workspace configuration first.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="container mx-auto p-6">
      <ConfigForm 
        config={config}
        onSubmit={handleSubmit}
        isLoading={updateConfig.isPending}
      />
    </div>
  )
}